import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '../../../styles';

import { ColumnContent } from '../../layout/components';
import { TextLink } from '../../pages/components';
import { AvatarComponent } from './';

const BioContainer = styled(ColumnContent)`
  width: 100%;
  &.fade-enter {
    opacity: 0;
  }

  &.fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 0.5s ease-in-out;
    transition-delay: 0.1s;
  }

  display: flex;
  ${props => props.breakpoint === 'desktop' ? `
    flex-direction: row;
    padding: 3.75rem 1.875rem;
  ` : `
    flex-direction: column;
    padding: 10rem 1.875rem;
  `}

    div.avatar {
  ${props => props.breakpoint === 'desktop' ? `
      width: 22.5806451612903%;
      margin-right: 7rem;
      flex-grow: 0;
      flex-shrink: 0;
      text-align: center;
  ` : `
      margin-bottom: 2rem;
  `}
    }
`;

const Container = styled.div`
  h3 {
    font-family: 'ApercuBold';
    font-size: 2rem;
    color: ${styles.color.BLACK};
    margin-bottom: 1em;
    text-transform: none;
  }
`;

const Bio = props => {
  const {
    breakpoint,
    person: { firstName, tagline, nationality, image, bio, website },
  } = props;

  return (
    <BioContainer breakpoint={breakpoint}>
      <AvatarComponent
        layout={breakpoint === 'desktop' ? 'column' : 'row'}
        className="avatar"
        imageSrc={image}
        firstName={firstName}
        tagLine={tagline}
        nationality={nationality}
      />
      <Container>
        <h3>About</h3>
        <div dangerouslySetInnerHTML={{ __html: bio }} />
        {website && (
          <TextLink to={website.url}>
            {website.title || website.url}
          </TextLink>
        )}
      </Container>
    </BioContainer>
  );
};

Bio.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  person: PropTypes.object.isRequired,
};

export default Bio;



// WEBPACK FOOTER //
// ./src/modules/people/components/Bio.js